/**
 * A11yAnnouncer - Provides a live region for screen reader announcements
 * 
 * This component should be rendered once at the root of the app.
 * Use the useAnnounce hook to make announcements.
 */
export const A11yAnnouncer = () => {
  return (
    <>
      {/* Polite announcements - won't interrupt current speech */}
      <div
        id="a11y-announcer-polite"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      
      {/* Assertive announcements - will interrupt current speech */}
      <div
        id="a11y-announcer-assertive"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      />
    </>
  );
};
